import React from 'react';
import NextLink from 'next/link';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';

interface LinkProps extends Omit<MuiLinkProps, 'href'> {
  href?: string;
  children: React.ReactNode;
}

const Link: React.FC<LinkProps> = ({ href, children, ...muiProps }) => {
  if (!href) {
    return (
      <MuiLink href={href} {...muiProps}>
        {children}
      </MuiLink>
    );
  }

  return (
    <MuiLink component={NextLink} href={href} {...muiProps}>
      {children}
    </MuiLink>
  );
};

export default Link;
